import React from 'react'
import { Container, Header , Card, Grid} from 'semantic-ui-react'
import insp1 from "../../../../../assets/images/insp1.png"
import insp2 from "../../../../../assets/images/insp2.png"
import insp3 from "../../../../../assets/images/insp3.png"
import insp4 from "../../../../../assets/images/insp4.png"
import "./Section2.css"

const Section2 = () => {
    return <Container className="Section2 p-1">
        <Header className="p-1-t p-1-b" size='huge'>Inspiration for your next trip</Header>
        <Grid columns={4} >
            <Grid.Row>
                <Grid.Column>
                    <Card
                        image={insp1}
                        header='Dresden'
                        description='115 kilometers away'
                        className="rounded-20 bg-red"
                    />
                    </Grid.Column>
                    <Grid.Column>
                    <Card
                    
                        image={insp2}
                        header='Meshkin Shahr'
                        description='600 kilometers away'
                        className="rounded-20 bg-pinkish"

                    />
                    </Grid.Column>
                    <Grid.Column>
                    <Card
                        image={insp3}
                        header='Paris'
                        description='1001 kilometers away'
                        className="rounded-20 bg-reddish"

                    />
                    </Grid.Column>
                    <Grid.Column>
                    <Card
                        image={insp4}
                        header='Gilan'
                        description='300 kilometers away'
                        className="rounded-20 bg-orange"

                    />
                </Grid.Column>
            </Grid.Row>
        </Grid>

     
</Container>
}
 export default Section2